import { StandardModal } from './StandardModal';

interface StandardConfirmProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  errorMessage?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Light-themed confirmation dialog composing `StandardModal`. Use inside any
 * Base UI flow that needs a yes/no decision. The dark `ConfirmDialog.tsx`
 * remains for legacy dark-surface flows (Dashboard).
 */
export function StandardConfirm({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = true,
  busy = false,
  errorMessage,
  onCancel,
  onConfirm,
}: StandardConfirmProps): JSX.Element {
  return (
    <StandardModal
      open={open}
      title={title}
      size="sm"
      onClose={busy ? () => undefined : onCancel}
      destructive={destructive}
      primaryAction={{ label: confirmLabel, onClick: onConfirm, busy }}
      secondaryAction={{ label: cancelLabel, onClick: onCancel, disabled: busy }}
    >
      <p className="text-sm" style={{ color: 'var(--bui-text-primary)' }}>
        {message}
      </p>
      {errorMessage && (
        <p
          role="alert"
          className="mt-3 rounded-md px-3 py-2 text-xs"
          style={{
            backgroundColor: 'var(--bui-danger-soft)',
            color: 'var(--bui-danger)',
          }}
        >
          {errorMessage}
        </p>
      )}
    </StandardModal>
  );
}
